/* eslint-disable no-mixed-operators */
import { RGB } from '../models';

export function generateLinearColourRamp(colours: readonly RGB[] | RGB[]): Map<number, RGB> {
  if (colours.length < 2) {
    throw new Error('At least two colours are required to generate a ramp');
  }

  const minVal = 1;
  const maxVal = 255;

  const ramp = new Map<number, RGB>();
  const totalSteps = maxVal - minVal + 1;
  const segmentCount = colours.length - 1;

  for (let index = 0; index < totalSteps; index++) {
    const position = index / (totalSteps - 1);
    const segment = Math.min(Math.floor(position * segmentCount), segmentCount - 1);
    const segmentPos = position * segmentCount - segment;

    const c1 = colours[segment];
    const c2 = colours[segment + 1];
    const color: RGB = [
      Math.round((1 - segmentPos) * c1[0] + segmentPos * c2[0]),
      Math.round((1 - segmentPos) * c1[1] + segmentPos * c2[1]),
      Math.round((1 - segmentPos) * c1[2] + segmentPos * c2[2]),
    ];
    ramp.set(minVal + index, color);
  }

  return ramp;
}
